////////// src/components/MapContext.js
import React, { createContext, useContext, useState } from "react";

const MapContext = createContext();

export const MapProvider = ({ children }) => {
  const [selectedRating, setSelectedRating] = useState(null);

  return (
    <MapContext.Provider value={{ selectedRating, setSelectedRating }}>
      {children}
    </MapContext.Provider>
  );
};

export const useMapContext = () => {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error("useMapContext must be used within a MapProvider");
  }
  return context;
};
